/** Returns true if the window global is defined */
export function hasWindow(): boolean {
  return typeof window !== 'undefined';
}

export function isAndroid() {
  if (!hasWindow()) {
    return false;
  }
  return navigator.userAgent.toLowerCase().indexOf('android') > -1;
}

// Not quite camel-case...
export function isiOS() {
  if (!hasWindow()) {
    return false;
  }
  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
      navigator.platform
    ) ||
    // iPadOS 13 reports that it's a Mac...
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
}

export function getSafariVersion() {
  if (!hasWindow()) {
    return false;
  }
  const ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('chrom') > -1 || ua.indexOf('safari') === -1) {
    return false;
  }
  const matches = ua.match(/version\/(\d+)/) || [];
  if (!matches.length) {
    return false;
  }
  return parseInt(matches[1]);
}

export function isDumbChromeIOS() {
  if (!hasWindow()) {
    return false;
  }
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('crios')) {
    return true;
  }

  return false;
}

export function scrollTo(el: any, x: number, y: number);
export function scrollTo(el: any, x: ScrollToOptions);
export function scrollTo(el: any, x: any, y?: any) {
  if (!hasWindow()) {
    return;
  }
  if ('scrollBehavior' in document.documentElement.style) {
    if (typeof x === 'number') {
      return el.scrollTo(x, y);
    }
    return el.scrollTo(x);
  }

  if (typeof x === 'number') {
    return el.scrollTo(x, y);
  }
  return el.scrollTo(x.left, x.top);
}

/** Returns true if the user's browser has hover (accrd. to media query) */
export function isBrowserHoverCapable(): boolean {
  return hasWindow() && window.matchMedia('(hover: hover)').matches;
}
